import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { Calendar } from "lucide-react";
import { Button } from "@/components/ui/button";

// Hero image in public folder for LCP discoverability via preload link
const heroImage = "/images/hero.webp";

const Hero = () => {
  return (
    <section className="relative min-h-[90vh] flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src={heroImage}
          alt="Aerial view of Son's Island private resort with thatched cabanas and docks at sunset"
          className="w-full h-full object-cover"
          width={1920}
          height={1080}
          fetchPriority="high"
          decoding="async"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-foreground/30 via-foreground/40 to-foreground/70" />
      </div>

      {/* Content */}
      <div className="container relative z-10 text-center text-background px-4">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="max-w-4xl mx-auto"
        >
          <motion.p
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.3 }}
            className="text-sm md:text-base uppercase tracking-[0.3em] text-background/80 mb-4"
          >
            Private Island Resort • Seguin, Texas
          </motion.p>

          <motion.h1
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.4, duration: 0.8 }}
            className="font-display text-5xl md:text-6xl lg:text-7xl font-bold mb-6 leading-tight"
          >
            Your Private Island
            <br />
            <span className="text-accent">Awaits</span>
          </motion.h1>

          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.6, duration: 0.8 }}
            className="text-lg md:text-xl lg:text-2xl text-background/90 mb-10 max-w-2xl mx-auto leading-relaxed"
          >
            Reserved cabanas. Private docks. Zero crowds.
            <br className="hidden md:block" />A lake day that actually feels like a vacation.
          </motion.p>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.8, duration: 0.8 }}
            className="flex flex-col sm:flex-row flex-wrap gap-4 justify-center items-center"
          >
            <Button asChild variant="hero" size="xl" className="flex items-center gap-2">
              <Link to="/book-now">
                <Calendar className="w-5 h-5" />
                Book Your Cabana
              </Link>
            </Button>

          </motion.div>
        </motion.div>
      </div>
    </section>
  );
};

export default Hero;
